function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.095 18.095v-16m0 0L1 7.81m6.095-5.714l6.096 5.714",
  stroke: "#333",
  strokeWidth: 2,
  strokeLinecap: "round"
});

function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgUpArrow;